import * as p from '@clack/prompts'
import pc from 'picocolors'

export interface ProjectPromptResult {
  projectName: string
}

/**
 * Prompt for the project name (fresh project only).
 */
export async function promptProject(defaultName?: string): Promise<ProjectPromptResult> {
  const projectName = await p.text({
    message: [
      'What is your project name?',
      `${pc.cyan('│')}  ${pc.dim("If you don't want a directory created with the project name, just press `")}${pc.bold(
        pc.cyan('.')
      )}${pc.dim('` and hit enter.')}`,
      pc.cyan('│')
    ].join('\n'),
    placeholder: defaultName ?? 'my-app',
    defaultValue: defaultName ?? 'my-app',
    validate: (value) => {
      if (!value?.trim()) return 'Project name is required'
      if (value.trim() === '.') return undefined
      if (!/^[a-z0-9_-]+$/i.test(value.trim())) {
        return 'Project name can only contain letters, numbers, hyphens, and underscores'
      }
      return undefined
    }
  })

  if (p.isCancel(projectName)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  return { projectName: projectName.trim() }
}
